export const PAGE_PATH = '/rating-list';
